import { render, staticRenderFns } from "./answerOfStudent.vue?vue&type=template&id=2921638d&"
import script from "./answerOfStudent.vue?vue&type=script&lang=js&"
export * from "./answerOfStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports